import { EstadisticasApi } from '../../services/api';
import { useLoading } from '../../utils/LoadingProvider';
import React, { useState, useEffect, useMemo } from 'react';

export const useEstadisticasModel = () =>{
    //estadisticas nuevas
    const [estadisticas, setEstadisticas] = useState();
    const [loadingestadisticas, setLoading] = useState(true);
    const [errorestadisticas, setError] = useState(null);

    //estadisticas anteriores
    const [estadisticasAnteriores, setEstadisticasAnteriores] = useState();
    const [loadingestadisticasAnteriores, setLoadingAnteriores] = useState(true);
    const [errorestadisticasAnteriores, setErrorAnteriores] = useState(null);

    //estadisticas marketing
    const [estadisticasMarketing, setEstadisticasMarketing] = useState();
    const [loadingestadisticasMarketing, setLoadingMarketing] = useState(true);
    const [errorestadisticasMarketing, setErrorMarketing] = useState(null);
    
    const {withLoading } = useLoading();

    const cargarEstadisticas = async(nombreEmpresa,fechaInicio,fechaFinal) =>{
        try{
            setLoading(true);
            const data = await EstadisticasApi.getEstadisticas(nombreEmpresa,fechaInicio,fechaFinal);
            console.log("estadisitcas data",data);
            setEstadisticas(data);
            setError(null);
            return data;
        }
        catch(error){
            console.error("Error al obtener estadisticas:", error);
            setError(error.message || "Error al cargar las estadsiticas");
            return null;
        }
        finally{
            setLoading(false);
        }
    };

    const cargarEstadisticasAnteriores = async(nombreEmpresa,fechaInicio,fechaFinal) =>{
        try{
            setLoadingAnteriores(true);
            const data = await EstadisticasApi.getEstadisticas(nombreEmpresa,fechaInicio,fechaFinal);
            console.log("estadisitcas data",data);
            setEstadisticasAnteriores(data);
            setErrorAnteriores(null);
            return data;
        }
        catch(error){
            console.error("Error al obtener estadisticas:", error);
            setErrorAnteriores(error.message || "Error al cargar las estadsiticas");
            return null;
        }
        finally{
            setLoadingAnteriores(false);
        }
    };

    //estadisticas de marketing
    const cargarEstadisticasMarketing = async(nombreEmpresa, fechaInicio,fechaFinal) =>{
        try{
            setLoadingMarketing(true);
            const data = await EstadisticasApi.getEstadisticasMarketing(nombreEmpresa,fechaInicio,fechaFinal);
            console.log("estadisitcas data",data);
            setEstadisticasMarketing(data);
            setErrorMarketing(null);
            return data;
        }
        catch(error){
            console.error("Error al obtener estadisticas:", error);
            setErrorMarketing(error.message || "Error al cargar las estadsiticas");
            return null;
        }
        finally{
            setLoadingMarketing(false);
        }
    }

    return{
        //estadisticas
        estadisticas,
        loadingestadisticas,
        errorestadisticas,
        cargarEstadisticas,

        //estadisticas anteriores
        estadisticasAnteriores,
        loadingestadisticasAnteriores,
        errorestadisticasAnteriores,
        cargarEstadisticasAnteriores,

        //estadisticas de marketing
        estadisticasMarketing,
        loadingestadisticasMarketing,
        errorestadisticasMarketing,
        cargarEstadisticasMarketing,

    }
    
}